<div class="relative h-24">
  <div class="absolute !w-full flex justify-evenly items-center h-24 top-0 z-20">
    @for (step of stepDeclarations; track step.stepName) {
      <div
        class="group {{
          step.isStepClickable ? 'cursor-pointer' : ''
        }} rounded-full size-5 relative flex justify-center items-center duration-300 transition-all"
        (click)="onClick(step)"
        [ngClass]="isHighlightedStep(step) ? 'bg-orgbrain-blue' : 'bg-white'"
      >
        <div
          class="rounded-full size-3"
          [ngClass]="isHighlightedStep(step) ? 'bg-white' : 'bg-slate-100'"
        ></div>

        <p
          class="absolute top-8 orgbrain-gray-text text-center w-24 {{
            step.isStepClickable ? 'group-hover:font-medium' : ''
          }}"
        >
          {{ step.stepTitle }}
        </p>

        <div
          class="bg-transparent absolute rounded-md w-24 h-16 -translate-x-1/2 p-0 -top-4 left-1/2"
        ></div>
      </div>
    }
  </div>
  <div class="absolute flex items-center h-24 top-0 !w-full z-10">
    <div class="flex-1 h-1 bg-slate-100">
      <div
        class="h-full duration-300 transition-all bg-orgbrain-blue"
        [ngStyle]="{ width: percentageCompleted + '%' }"
      ></div>
    </div>
  </div>
</div>
